import { createRouter, createWebHistory } from 'vue-router'
import apisAccessRecords from '@/apis/apisAccessRecords'
import AboutView from '../views/AboutView.vue'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import CountView from '../views/AccountView.vue'
import MyCompanysView from '../views/MyCompanysView.vue'
import RegistreView from '../views/RegistreView.vue'
import RecuperarClaveView from '../views/RecuperarClaveView.vue'
import EditCompanyView from '../views/DynamicViews/EditCompanyView.vue'
import MyPaymentsView from '@/views/MyPaymentsView.vue'
import ViewCompanyView from '@/views/DynamicViews/ViewCompanyView.vue'
import ViewProductView from '@/views/DynamicViews/ViewProductView.vue'
import CompanysView from '@/views/SitesView.vue'
import ProductsView from '@/views/ProductsView.vue'
import SearchView from '@/views/DynamicViews/SearchView.vue'
import SearchProductView from '@/views/DynamicViews/SearchProductView.vue'
import SearchCompanysView from '@/views/DynamicViews/SearchCompanysView.vue'
import UsersView from '@/views/UsersView.vue'
import AllCompanysView from '@/views/AllCompanysView.vue'
import AdminSitesView from '@/views/AdminSitesView.vue'
import AccessDashboardView from '@/views/AccessDashboardView.vue'
import AdminSettingsView from '@/views/AdminSettingsView.vue'
import SitesPublicView from '@/views/SitesPublicView.vue'
import ViewSiteView from '@/views/DynamicViews/ViewSiteView.vue'
import LandingEmpezarView from '@/views/LandingEmpezarView.vue'
import RutasView from '@/views/RutasView.vue'
import ViewRutaView from '@/views/DynamicViews/ViewRutaView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/Companys',
    name: 'CompanysView',
    meta: { titulo: 'Empresas' },
    component: CompanysView
  },
  {
    path: '/Products',
    name: 'ProductsView',
    meta: { titulo: 'Productos' },
    component: ProductsView
  },
  {
    path: '/empezar',
    name: 'LandingEmpezarView',
    meta: { titulo: 'Publica tu negocio' },
    component: LandingEmpezarView
  },
  {
    path: '/Login',
    name: 'LoginView',
    meta: { titulo: 'Iniciar sesión' },
    component: LoginView
  },
  {
    path: '/account',
    name: 'CountView',
    meta: { titulo: 'Mi cuenta' },
    component: CountView
  },
  {
    path: '/myCompanys',
    name: 'myCompanysView',
    meta: { titulo: 'Mis empresas' },
    component: MyCompanysView
  },
  {
    path: '/register',
    name: 'RegistreView',
    meta: { titulo: 'Crear cuenta' },
    component: RegistreView
  },
  {
    path: '/recuperarClave',
    name: 'RecuperarClaveView',
    meta: { titulo: 'Recuperar contraseña' },
    component: RecuperarClaveView
  },
  {
    path: '/editMyCompany/:id',
    name: 'EditCompanyView',
    meta: { titulo: 'Editar empresa' },
    component: EditCompanyView
  },
  {
    path: '/myPayments',
    name: 'MyPaymentsView',
    meta: { titulo: 'Mis pagos' },
    component: MyPaymentsView
  },
  {
    path: '/viewCompany/:id',
    name: 'ViewCompanyView',
    component: ViewCompanyView
  },
  {
    path: '/viewProduct/:id',
    name: 'ViewProductView',
    component: ViewProductView
  },
  {
    path: '/search/:query',
    name: 'SearchView',
    component: SearchView
  },
  {
    path: '/searchCompanys/:query',
    name: 'SearchCompanysView',
    component: SearchCompanysView
  },
  {
    path: '/searchProduct/:query',
    name: 'SearchProductView',
    component: SearchProductView
  },
  {
    path: '/Users',
    name: 'UsersView',
    meta: { titulo: 'Usuarios' },
    component: UsersView
  },
  {
    path: '/AllCompanysView',
    name: 'AllCompanysView',
    meta: { titulo: 'Todas las empresas' },
    component: AllCompanysView
  },
  {
    path: '/AdminSites',
    name: 'AdminSitesView',
    meta: { titulo: 'Administrar lugares' },
    component: AdminSitesView
  },
  {
    path: '/Dashboard',
    name: 'AccessDashboardView',
    meta: { titulo: 'Estadísticas' },
    component: AccessDashboardView
  },
  {
    path: '/AdminSettings',
    name: 'AdminSettingsView',
    meta: { titulo: 'Configuración' },
    component: AdminSettingsView
  },
  {
    path: '/Sites',
    name: 'SitesPublicView',
    meta: { titulo: 'Lugares' },
    component: SitesPublicView
  },
  {
    path: '/Rutas',
    name: 'RutasView',
    meta: { titulo: 'Rutas' },
    component: RutasView
  },
  {
    // Por slug y no por id: es el enlace que se comparte y el que posiciona.
    // Sin meta.titulo a proposito, lo pone la vista con el nombre real.
    path: '/ruta/:slug',
    name: 'ViewRutaView',
    component: ViewRutaView
  },
  {
    path: '/viewSite/:id',
    name: 'ViewSiteView',
    component: ViewSiteView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: { titulo: 'Página no encontrada' },
    component: AboutView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

/**
 * Titulo del documento por ruta.
 *
 * Antes las veinte paginas compartian el mismo <title>, asi que en Google la
 * ficha de una empresa y la portada se veian identicas y ninguna posicionaba
 * por su nombre. Para un directorio, que vive de que lo encuentren, eso pesa.
 *
 * Las vistas de detalle (empresa, producto, lugar) no salen de aqui: cuando
 * cargan sus datos llaman a ponerTitulo() con el nombre real. Aqui se pone el
 * titulo base para que no se quede el de la pagina anterior mientras carga.
 */
export const TITULO_BASE = 'Bahiol — Directorio colombiano de empresas y lugares'

/**
 * Donde vive el sitio de verdad.
 *
 * OJO: NO es folustecno.com, que es otra web. index.html tenia el canonical
 * apuntando alla, y como es una sola pagina ese canonical valia para TODAS
 * las rutas: a Google se le estaba diciendo que cada empresa, cada producto y
 * cada ruta eran duplicados de la portada de otro dominio. Por eso ninguna
 * llegaba a indexarse, aunque respondieran bien.
 */
export const DOMINIO = 'https://bahiol.folustecno.com'

/**
 * Deja el canonical apuntando a la URL que se esta viendo.
 *
 * Con un canonical fijo en index.html no basta: en una sola pagina, el que
 * viene en el HTML es el mismo para todo el sitio. Google ejecuta el
 * JavaScript antes de decidir, asi que cambiarlo aqui si lo tiene en cuenta.
 */
export function ponerCanonical(camino) {
  let etiqueta = document.querySelector('link[rel="canonical"]')

  if (!etiqueta) {
    etiqueta = document.createElement('link')
    etiqueta.setAttribute('rel', 'canonical')
    document.head.appendChild(etiqueta)
  }

  etiqueta.setAttribute('href', DOMINIO + camino)

  // og:url va de la mano: es la que se ve al compartir por WhatsApp, y
  // apuntaba al mismo dominio equivocado
  let og = document.querySelector('meta[property="og:url"]')

  // index.html ya no la trae (ver el comentario de alla), asi que se crea
  if (!og) {
    og = document.createElement('meta')
    og.setAttribute('property', 'og:url')
    document.head.appendChild(og)
  }

  og.setAttribute('content', DOMINIO + camino)
}

export function ponerTitulo(texto) {
  document.title = texto ? `${texto} | Bahiol` : TITULO_BASE
}

router.afterEach((to) => {
  const query = to.params.query

  // Sin la query string: ?page=2 no es una pagina distinta para Google, y
  // dejarla genera duplicados que compiten entre si
  ponerCanonical(to.path)

  if (to.meta && to.meta.titulo) {
    ponerTitulo(to.meta.titulo)
  } else if (query) {
    ponerTitulo(`Resultados para "${query}"`)
  } else {
    ponerTitulo(null)
  }

  apisAccessRecords.register(to.fullPath).catch(() => {})
})

export default router
